module.exports = __webpack_public_path__ + "static/media/11.cb6a8067.jpg";